import React from "react";

const DropdownLink = props => {

  return (
    <li className="dropdown__item">
      <a href={props.to} target={props.target} className="dropdown__link" onClick={props.onClick}>
        {props.children}
      </a>
    </li>
  );
}

DropdownLink.defaultProps = {
  target: "_blank"
}

export default DropdownLink;